import React, {memo, useCallback, Ref, useState} from "react";
import UserImageUploader from "../Loadable";
import {UploadFileBox} from "../../GenericUpload/widgets/Styled";
import {setFileBlobURLOrError} from "../utils";
import {PhotoUploadSection} from "./styled";
import ForwardRef from "../../../hoc/ForwardRef";
import PopUp from "../../PopUp/Loadable";
import UserImageErrorLayer from "./UserImageErrorLayer";

interface Props {
    heading: string;
    type?: "button" | "text";
    forwardRef?: Ref<HTMLInputElement>;
    id: string;
    onChange: (url: string) => void;
    disableBack?: boolean;
    consentFormStyle?: boolean;
    rff?: Record<string, unknown>;
}
const ImageSelectorInput: React.FC<Props> = ({
    heading,
    type = "button",
    forwardRef,
    id,
    onChange,
    disableBack = false,
    consentFormStyle,
    rff,
}: Props) => {
    const [errorMsg, setErrorMsg] = useState<string | null>(null);
    const onSelectFile = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const response = setFileBlobURLOrError({
                event,
            });
            if (response) {
                if (response.success === false) {
                    setErrorMsg(response?.msg);
                } else {
                    onChange && onChange(response?.msg);
                }
            }
        },
        [onChange],
    );
    const preloadDependancies = useCallback(() => {
        PopUp.preload();
        UserImageUploader.preload();
    }, []);

    const jsx = (
        <>
            <label htmlFor={id}>{heading}</label>
            <input
                {...(rff ? {...rff} : {})}
                id={id}
                type="file"
                accept="image/*"
                multiple={false}
                onChange={(e) => {
                    onSelectFile(e);
                    //@ts-expect-error dfjds
                    rff?.onChange(e);
                }}
                ref={forwardRef}
            />
            {errorMsg && (
                <UserImageErrorLayer
                    errorMsg={errorMsg}
                    setErrorMsg={setErrorMsg}
                    disableBack={disableBack}
                />
            )}
        </>
    );

    if (type === "button") {
        return (
            <UploadFileBox onMouseEnter={preloadDependancies} onTouchStart={preloadDependancies}>
                {jsx}
            </UploadFileBox>
        );
    } else {
        return (
            <PhotoUploadSection
                onMouseEnter={preloadDependancies}
                onTouchStart={preloadDependancies}
                consentFormStyle={consentFormStyle}
            >
                {jsx}
            </PhotoUploadSection>
        );
    }
};

export default memo(ForwardRef<Props, HTMLInputElement>(ImageSelectorInput));
